export default __webpack_public_path__ + "static/media/Etape9_LaManu_After_Filtre.3d64caea.jpg";